// src/layouts/person/data/personTableData.js
/* eslint-disable */
import MDBox from "components/MDBox";
import IconButton from "@mui/material/IconButton";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import { normalizeOptionalText } from "utils/personOptionalFields";
import ClientNameButton from "layouts/person/ClientNameButton";

const displayCell = (value) => normalizeOptionalText(value) ?? "-";

export default function personTableData({ persons, onEdit, onToggle, expandedPersonId }) {
  return {
    columns: [
      { Header: "Nombre", accessor: "Name", align: "left" },
      { Header: "Contacto", accessor: "Contact", align: "left" },
      { Header: "Ciudad", accessor: "City", align: "left" },
      { Header: "", accessor: "Actions", align: "left" },
    ],

    rows: persons.map((person) => ({
      _person: person,
      Name: (
        <ClientNameButton
          person={person}
          expanded={expandedPersonId === person.Id}
          onToggle={onToggle}
        />
      ),
      Contact: displayCell(person.Contact),
      City: `${displayCell(person.Department)} · ${displayCell(person.City)}`,
      Actions: (
        <MDBox>
          <IconButton
            name="updatePerson"
            aria-label={`Editar ${displayCell(person.Name)}`}
            color="primary"
            onClick={() => onEdit(person.Id)}
          >
            <DriveFileRenameOutlineIcon />
          </IconButton>
        </MDBox>
      ),
    })),
  };
}
